import { getAgencyUi } from '@va/standalone/shared/actions';
import { getAgencyUi as selectAgencyUi } from '@va/standalone/shared/selectors';
import Config from 'Config';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export type AgencyDomainType = 'custom-subdomain' | 'custom-domain';

export const useGetLiveAgencyDomain = () => {
  const agencyUi = useSelector(selectAgencyUi);

  const agencyDomainType = useMemo((): AgencyDomainType | undefined => {
    if (!agencyUi?.customUrl) return;
    if (agencyUi.customUrl.includes(Config.customDomain)) return 'custom-subdomain';
    return 'custom-domain';
  }, [agencyUi?.customUrl]);

  const dispatch = useDispatch();

  const mutate = useCallback(() => {
    dispatch(getAgencyUi());
  }, [dispatch]);

  return {
    customUrl: agencyUi?.customUrl,
    domainType: agencyDomainType,
    mutate: mutate,
  };
};
